import React from "react";
import { BrainIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
export function Hero() {
  return <header className="px-4 pb-14 pt-6 md:pb-20 md:pt-10" data-id="element-160" data-mp="cvl3r30odasi">
      <div className="mx-auto max-w-5xl text-center" data-id="element-161" data-mp="huxsxuf0qty9">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-162" data-mp="hvqqc4s3873q">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-700 text-white" data-id="element-163" data-mp="mutvrqbzcfc8">
            <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-164" data-mp="qukk7ne1ajdl" />
          </span>
          <span className="font-serif text-xl font-extrabold text-brand-900" data-id="element-165" data-mp="vlu8ajjxpend">Sensory Decision Map™</span>
        </div>

        <p className="mt-5 inline-block rounded-full border border-brand-200 bg-white px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-700 sm:text-xs" data-id="element-166" data-mp="10kdtghqpemeo">
          The Sensory Decision Map™ Protocol
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl text-balance font-serif text-[2.35rem] font-black leading-[1.06] text-ink sm:text-5xl md:text-[4rem]" data-id="element-167" data-mp="1ajuxkuqb4s8j">
          Organize a sensory case in{" "}
          <em className="text-brand-600" data-id="element-168" data-mp="4n51ir9830d4">15 minutes</em> — without getting lost in theory
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-pretty text-[17px] leading-relaxed text-muted md:text-xl" data-id="element-169" data-mp="3vvas6f0g8hev">
          A step-by-step clinical reasoning system that helps Occupational Therapists turn scattered observations into an
          organized working hypothesis. Includes <strong className="text-ink" data-id="element-170" data-mp="ng8usbij3b77">6 Premium Volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-171" data-mp="io9316cm3olp">5 Professional Bonuses</strong> and{" "}
          <strong className="text-ink" data-id="element-172" data-mp="im4ozvl0197p">30+ decision tools</strong>.
        </p>

        <img src={images.mockup} alt="The 6 volumes and 5 bonuses of the Sensory Decision Map™" className="mx-auto mt-6 w-full max-w-2xl" width={1080} height={1080} data-id="element-173" data-mp="emnhkwm0i1zw" />

        <div className="mt-4" data-id="element-174" data-mp="30lxe0b30qcx8">
          <CtaButton id="hero-cta" label="Get the Sensory Decision Map™" note="Instant digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee" data-id="element-175" data-mp="30lnoeolvy7s2" />
        </div>

        <Countdown data-id="element-176" data-mp="2qvkv0nauqrt7" />
      </div>
    </header>;
}